import { render, staticRenderFns } from "./Aprobacion.vue?vue&type=template&id=55899f4f"
import script from "./Aprobacion.vue?vue&type=script&lang=js"
export * from "./Aprobacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55899f4f')) {
      api.createRecord('55899f4f', component.options)
    } else {
      api.reload('55899f4f', component.options)
    }
    module.hot.accept("./Aprobacion.vue?vue&type=template&id=55899f4f", function () {
      api.rerender('55899f4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/oficial-registro/Aprobacion.vue"
export default component.exports